export const usePushNotificationEvent = (): void => {}
